"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.error ?? "Une erreur est survenue");
        return;
      }
      setDone(true);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center space-y-2">
          <Image src="/logo.svg" alt="OpusLouange" width={40} height={40} className="w-10 h-10 mx-auto" />
          <h1 className="text-2xl font-semibold tracking-tight">Mot de passe oublié</h1>
          <p className="text-muted-foreground text-sm">
            Entrez votre email pour recevoir un lien de réinitialisation
          </p>
        </div>

        {done ? (
          <div className="space-y-4">
            <p data-testid="forgot-password-success" className="text-sm text-center bg-muted px-4 py-3 rounded-lg leading-relaxed">
              Si un compte existe pour <strong>{email}</strong>, vous recevrez un email dans les prochaines minutes.
            </p>
            <p className="text-center text-sm text-muted-foreground">
              <Link href="/auth/login" className="text-foreground font-medium hover:underline underline-offset-4">
                Retour à la connexion
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <p data-testid="auth-error" className="text-sm text-destructive bg-destructive/10 px-3 py-2 rounded-lg">{error}</p>
            )}
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                data-testid="forgot-password-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                placeholder="vous@exemple.com"
                className="h-10"
              />
            </div>
            <Button data-testid="forgot-password-submit" type="submit" disabled={loading} className="w-full h-10 text-sm font-medium">
              {loading ? "Envoi…" : "Envoyer le lien"}
            </Button>
            <p className="text-center text-sm text-muted-foreground">
              <Link href="/auth/login" className="text-foreground font-medium hover:underline underline-offset-4">
                Retour à la connexion
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
